import SuperRepository from '../superRepository'

export default new (class CountryRepository extends SuperRepository {
  baseUri() {
    return 'country'
  }
})()
